import React from 'react';

export const splitWord = (word: string): string => {
    const splitWord = word.replace(/([A-Z])/g, ' $1');
    return splitWord.trim();
};